'use client';

import { ArrowUp } from 'lucide-react';

export function UpButton() {
  const handleScrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  return (
    <button
      title="Voltar ao topo"
      className="float-right bg-green-500 rounded-full p-1.5 mb-4 text-secondary"
      onClick={handleScrollToTop}
    >
      <ArrowUp size={18} />
    </button>
  );
}
